<template>
  <div class="">
  <div class="table-page-search-wrapper">
    <a-row :gutter="12" style="margin:0px 0px 16px 0px;">
        <!-- <a-col class="a-large-form" >
          <a-form-item label="" style="margin-bottom:0px">
            <a-input placeholder="请输入课程名称" style="width:100%" v-model="queryParam.name"></a-input>
          </a-form-item>
        </a-col> -->
        <a-button @click="oneKeyPk" type="primary" style="margin-left:10px;vertical-align: middle;">一键排课</a-button>
        <!-- <a-button @click="searchQuery" type="primary" style="margin-left:10px;vertical-align: middle;">筛选</a-button> -->
        <a-button  type="primary" style="margin-left:10px;vertical-align: middle;" @click="batchDel">批量删除</a-button>

        <a-col style="float:right;">
          <span style="margin-bottom:0px" class="table-page-search-submitButtons">
            <!-- <a-button @click="courseHoursCreate()" type="primary" icon="plus" style="margin-left:8px;">新增课时</a-button> -->
            <!-- <a-button @click="courseChapterCreate()" type="primary" icon="plus" style="margin-left:8px;">新增章节</a-button> -->
          </span>
        </a-col>
      </a-row>
  </div>
  <div>
      <a-table
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        ref="table"
        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :loading="loading">


        <!--  -->
        <span slot="repeatTypeRed" slot-scope="text,record,index">
            <div>
              {{record.repeatType_dictText}}循环
            </div>
        </span>

        <span slot="shijian" slot-scope="text,record">
            <div>{{record.startTime  }} ~ {{record.endTime}}</div>
        </span>
        
        <span slot="action" slot-scope="text, record,index">


          <span >
              <a @click="timeTableEdit(record)"  >编辑</a>
              <a-divider type="vertical" />
               <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
          </span>
        </span>

        <!-- <span slot="courseName" slot-scope="text, record">
          <span style='color:#333;font-size:14px;'>{record.courseName}</span>
          <span style='color:#999;font-size:12px;'>{record.time}</span>
        </span> -->

      </a-table>
    </div>
    <ToPlanClassModal ref="toPlanClassModal" :courseId = "queryParam.courseId" @ok = "loadData" />
  </div>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import ToPlanClassModal from './ToPlanClassModal'

  import {deleteChapter,deleteCourseHour,courseHourShelf,chapterShelf,getGradeTableList} from '@/api/api'

  export default {
    name: 'ClassHourManage',
    components: {
      ToPlanClassModal
    },
    mixins: [JeecgListMixin],
    data() {
      return {
        selectedRowKeys: [],
        firstIsNotLoad:true,
        queryParam:{
          gradeId:"",
          name:""
        },
        loading:false,
        visible:false,
        description:"课时管理",
        url: {
          list: "/grade/elinkxGradeTimetable/list",
          delete: "/grade/elinkxGradeTimetable/delete",
          deleteBatch: "/grade/elinkxGradeTimetable/deleteBatch",
          exportXlsUrl: "course/elinkxCourse/exportXls",
          importExcelUrl: "course/elinkxCourse/importExcel",
        },
        columns: [
          {
            title: '排课方式',
            align:"left",
            dataIndex: 'repeatTypeRed',
            width:120,
            scopedSlots: { customRender: 'repeatTypeRed' },
          },
          {
            title: '上课日期',
            align:"center",
            dataIndex: 'riqi',
            width:250,
            customRender: (text, row, index) => {
              // 2 限日期
              var repeatName = row.repeatType_dictText;
              let weekArr = row.weeklyCycle_dictText.split(',');
              let weekString = "";
              console.log(row.endDate)
              weekArr.map((item,i)=>{
                if(i==0){
                  weekString=weekString+repeatName+"的周"+item 
                }else{
                  weekString+="、周"+item 
                }
              })
              if (row.endMode == 2) {
                return row.startDate+"日~"+row.endDate +"日 "+weekString;
              }else{
                return row.startDate+"日开始 " +""+weekString;
              }
              
            } 
          },
          {
            title: '上课时间',
            align:"center",
            dataIndex: 'shijian',
            width:150,
            scopedSlots: { customRender: 'shijian' },
          },
          {
            title: '上课老师',
            align:"center",
            dataIndex: 'teacherNames',
            width:110
          },
          {
            title: '上课内容',
            align:"center",
            dataIndex: 'courseContent',
            width:160
          },
         
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            scopedSlots: { customRender: 'action' },
            width:200
          }
        ],
        dataSource:[
         
        ],
      }
    },
   
    created(){
      this.queryParam.gradeId = this.$route.query.id;
      this.loadData();
      // alert(this.queryParam.courseId)
      // console.log("123");
    },
   
    methods: {
      onSelectChange(selectedRowKeys) {
        console.log('selectedRowKeys changed: ', selectedRowKeys);
        this.selectedRowKeys = selectedRowKeys;
      },
      // 一键排课
      oneKeyPk(){
        this.$refs.toPlanClassModal.add(this.queryParam.gradeId)
      },
      // 新增章节
      courseChapterCreate(){
        this.$router.push({ path:'/myCourse/courseChapterCreate?courseId='+this.queryParam.courseId});
      },

      // 删除章节
      timeDel(chapterIdPram){
        deleteChapter({id:chapterIdPram}).then((res)=>{
          if(res.code==0){
            this.$message.success(res.message);
            this.loadData();
          }else{
            this.$message.warning(res.message);
          }

        }).finally(() => {
          
        })
      },

      // 编辑章节
      timeTableEdit(item){
        this.$refs.toPlanClassModal.add(this.queryParam.gradeId,item)
      },
      // 课时上下架


      // 删除课时
      courseHoursDel(item){
        deleteCourseHour({id:item.id}).then((res)=>{
          if(res.code==0){
            this.$message.success(res.message);
            this.loadData();
          }else{
            this.$message.warning(res.message);
          }

        }).finally(() => {
          
        })
      },
      // 课时上下架
      courseHourShelf(idParam){
        courseHourShelf({id:idParam}).then((res)=>{
          if(res.success==true){
            this.$message.success(res.message);
            this.loadData();
          }else{
            this.$message.warning(res.message);
          }

        }).finally(() => {
          
        })
      },
      
    }
  }
</script>

<style scoped>

</style>